import React from 'react';
import styled from 'styled-components';
import Title from '../../components/common/Title';
import klinikken from '../../assets/Klinikken.jpg';


const Container = styled.div`
  display: flex;
  flex-direction: column;

  padding: 2rem 2rem 0 2rem;
  margin: auto;
  max-width: 80rem;
`;

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 65% 1fr;
  column-gap: 1%;
  margin-top: 2rem;
  padding-bottom: 2rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
  }
`;

const TextContainer = styled.div``;

const ImageContainer = styled.div`
min-height:300px;`;

const TextContent = styled.p`
  font-size: 1.3rem;
  white-space: pre-wrap;
  margin-bottom: 1.5rem;
`;

const Clinic = () => {
  return (
    <Container>
      <Title text='Klinikken'></Title>
      <ContentContainer>
        <TextContainer>
          <TextContent>
            {
              'Helsehuset Vea er en veletablert klinikk på industriområdet i Veakrossen med besøksadresse Bleikmyrvegen 42.'
            }
            {'\n\n'}
            {
              'Klinikken er 542,5 kvm og inneholder bl.a. 6 behandlingsrom og eget treningssenter med utstyr tilpasset pasienter i alle aldre.'
            }
            {'\n\n'}
            {
              'På klinikken jobber 5 fysioterapeuter med offentlig godkjenning, både med og uten driftstilskudd (refusjon fra Folketrygden).'
            }
          </TextContent>
        </TextContainer>
        <ImageContainer>
        <img src={klinikken} alt='Kontor' />
        </ImageContainer>
      </ContentContainer>
    </Container>
  );
};

export default Clinic;
